import React from "react";

import TowerTravelFormPageContainer from "./TowerTravelFormPageContainer";

export class TowerTravelFormPage extends React.Component {
  render() {
    return <TowerTravelFormPageContainer {...this.props} />;
  }
}
